module.exports = __webpack_public_path__ + "static/img/QRCode.44ea3ca1.png";